import styled from 'styled-components';
import { flexbox, flexDirection, alignItems, justifyContent } from '../../../styles/helpers/flexbox';
import ThemeHelper from '../../../themes/theme-helper';

const Wrapper = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
  ${flexbox()};
  ${flexDirection('column')};

  min-height: calc(100% - 192px);
  border: 1px solid ${colours.grey[400]};;
  background-color: ${colours.grey[200]};
`;
});

const Header = styled.header((props) => {
  const { colours } = ThemeHelper.getTheme(props);
  return `
        ${flexbox()};

        position: sticky;
        top: 192px;
        z-index: 1;
        width: 54px;
        height: 47px;
        min-height: 47px;
        background-color: ${colours.grey[400]};
        border-right: 1px solid ${colours.grey[500]};
        box-sizing: border-box;
`;
});

const CellContainer = styled.div`
  ${flexbox()};
  ${alignItems('center')};
  ${justifyContent('center')};
`;

const GridColumn = styled.div`
    ${flexbox()};
    ${flexDirection('column')};
`;

export {
  Wrapper,
  Header,
  CellContainer,
  GridColumn };
